import { NgModule } from '@angular/core';
import { LearningGameCoreModule } from './learning-game-core';
import { ValuesGameCoreModule } from './values-game-core';

@NgModule({
  declarations: [],
  imports: [],
  exports: [LearningGameCoreModule, ValuesGameCoreModule],
})
export class MasterGameCoreModule {}
